var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.researchLinkList),function(link){return [_c('a',{attrs:{"target":"_blank","href":link.Link},domProps:{"textContent":_vm._s(link.Name)}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }